import React, { useState } from "react";
import { Button, FloatingLabel, Form, Spinner } from "react-bootstrap";
import Api from "../../services/ApiService";

const PassForgotForm = (props) => {

    const API = new Api();

    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [errMsg, setErrMsg] = useState("");

    const submitHandler = (e) => {
        e.preventDefault();
        setErrMsg("");
        setIsLoading(true);
        API.password_send_mail(email)
            .then(res => {
                let data = res.data;
                if (data.hv === true) {
                    props.view('pass-forgot-hv');
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                    props.view('pass-forgot-done');
                }
            })
            .catch((err) => {
                setIsLoading(false);
                setErrMsg(err.response.data.detail);
            })
    } 

    return (
        <Form onSubmit={e => submitHandler(e)}>
            <Form.Group className="mb-3">
                <FloatingLabel label="E-Mail-Adresse">
                    <Form.Control type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-Mail-Adresse" />
                </FloatingLabel>
                <Form.Text className="text-danger">
                    <b>{errMsg}</b>
                </Form.Text>
            </Form.Group>
            {isLoading? 
                <Spinner animation="border" variant="warning" />
            :
                <Button variant="warning" type="submit">Passwort zurücksetzen</Button>
            }
        </Form>
    )
}

export default PassForgotForm